import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";
import { RangeView } from "../firstPageComponents/range";

export const OnuSlaFirstPage = ({ relatorio, sharedOptions }) => {
  return (
    <View style={styles.firsPageContainer}>
      {<RangeView sharedOptions={sharedOptions} />}
      {
        <Text
          style={styles.stylesReportIntro.clientTitle}
        >{`Cliente : ${relatorio?.client?.toUpperCase()}`}</Text>
      }
      {
        <Text
          style={[styles.text, { textIndent: "20px" }]}
        >{`Este relatório apresenta o acompanhamento dos indicadores de desempenho (SLA) dos equipamentos ONU monitorados no período de ${sharedOptions?.dataInicial} a ${sharedOptions?.dataFinal}. Foram analisadas as métricas de Potência Recebida (dBm) e Disponibilidade, com base nos dados coletados automaticamente pelos sistemas de monitoramento. O objetivo é avaliar a qualidade do enlace óptico e a estabilidade operacional dos equipamentos, assegurando a conformidade com os níveis de serviço estabelecidos.`}</Text>
      }
    </View>
  );
};
